import styled from "styled-components";

export const MyReservationFilterWrapper = styled.div`
  position: relative;

  > .label {
    height: 30px;
    width: 
    gap: 2px;
    border-radius: 15px;
    padding-top: 9px;
    padding-right: 8px;
    padding-bottom: 9px;
    padding-left: 12px;
    border: 1px solid var(--Black-200, #b7b7b7);
    
    font-weight: 600;
    font-size: 12px;
    display: flex;
    align-items: center;
  }

  > .filter-wrapper {
    position: absolute;
    top: 35px;
    width: auto;
    border-radius: 8px;
    padding: 12px;
    gap: 4px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px #0000001f;
    display: flex;
    flex-direction: column;
    gap: 4px;

    > .filter-item {
      height: 30px;
      border-radius: 15px;
      gap: 2px;
      padding-top: 8px;
      padding-right: 12px;
      padding-bottom: 8px;
      padding-left: 12px;
      
      font-weight: 600;
      font-size: 12px;
      line-height: 100%;
      border: 1px solid var(--Black-100, #f0f0f0);
      white-space: nowrap;
      text-align: center;

      &.select {
        background: var(--Purple-300, #6436e7);
        color: #fff;
      }
    }
  }
`;
